import caller from "../../helpers/caller";

export default async function deleteDocumentSubType(api, id) {
  const response = await caller(api.delete, "/document_sub_type/delete", null, {
    params: { id },
  });
  return response;
}
